import React, { FC } from 'react';

type Props = {
  htmlFor: string;
};

export const DecisionUploadFormLabel: FC<Props> = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor}>{children}</label>
);

export const DecisionUploadFormError: FC = ({ children }) => {
  return <div className="form-error is-visible">{children}</div>;
};
